// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_2640c02","navContainer":"_2adcb57","embeddedContainer":"_3f016c4","nav":"_7035c59","button":"_e67c48f","active":"_ec2ee4c","disabled":"_3f9bf95"};